
const POUNDS_PER_KILOGRAM = 2.20462
const KILOGRAMS_PER_POUND = 0.453592

export const kgToLbs = (kg?: number | null): number => {
  if (!kg) return 0
  return kg * POUNDS_PER_KILOGRAM
}

export const lbsToKg = (lbs?: number | null): number => {
  if (!lbs) return 0
  return lbs * KILOGRAMS_PER_POUND
}
